import api from './api';

// Upload & Import
export const uploadPreview = (transactions) =>
  api.post('/bank-transactions/upload-preview', { transactions }).then(r => r.data);

export const importTransactions = (transactions) =>
  api.post('/bank-transactions/import', { transactions }).then(r => r.data);

// Manual Create
export const createBankTransaction = (data) =>
  api.post('/bank-transactions/create', data).then(r => r.data);

// List & Filter
export const getBankTransactions = (params = {}) =>
  api.get('/bank-transactions', { params }).then(r => r.data);

export const getBankTransactionsSummary = (params = {}) =>
  api.get('/bank-transactions/summary', { params }).then(r => r.data);

export const getFilterOptions = () =>
  api.get('/bank-transactions/filter-options').then(r => r.data);

// Update & Delete
export const updateBankTransaction = (id, data) =>
  api.put(`/bank-transactions/${id}`, data).then(r => r.data);

export const deleteBankTransaction = (id) =>
  api.delete(`/bank-transactions/${id}`).then(r => r.data);

export const getDeletedBankTransactions = () =>
  api.get('/bank-transactions/deleted').then(r => r.data);

export const restoreBankTransaction = (id) =>
  api.post(`/bank-transactions/${id}/restore`).then(r => r.data);

export const permanentDeleteBankTransaction = (id) =>
  api.delete(`/bank-transactions/${id}/permanent`).then(r => r.data);

export const bulkRestoreTransactions = (transaction_ids) =>
  api.post('/bank-transactions/bulk-restore', { transaction_ids }).then(r => r.data);

export const bulkPermanentDeleteTransactions = (transaction_ids) =>
  api.post('/bank-transactions/bulk-permanent-delete', { transaction_ids }).then(r => r.data);

export const purgeOldDeleted = (days = 30) =>
  api.post(`/bank-transactions/purge-old-deleted?days=${days}`).then(r => r.data);

export const bulkCategorize = (data) =>
  api.post('/bank-transactions/bulk-categorize', data).then(r => r.data);

// Categories
export const getTransactionCategories = () =>
  api.get('/bank-transactions/categories').then(r => r.data);

export const createTransactionCategory = (data) =>
  api.post('/bank-transactions/categories', data).then(r => r.data);

export const updateTransactionCategory = (id, data) =>
  api.put(`/bank-transactions/categories/${id}`, data).then(r => r.data);

export const deleteTransactionCategory = (id) =>
  api.delete(`/bank-transactions/categories/${id}`).then(r => r.data);

// AI Categorize
export const aiCategorize = (transaction_ids) =>
  api.post('/bank-transactions/ai-categorize', { transaction_ids }, { timeout: 120000 }).then(r => r.data);

export const aiParseInstruction = (transaction_id, instruction) =>
  api.post('/bank-transactions/ai-parse-instruction', { transaction_id, instruction }, { timeout: 60000 }).then(r => r.data);

// Report
export const getTransactionReport = (params = {}) =>
  api.get('/bank-transactions/report', { params }).then(r => r.data);

// Link / unlink transaction to a tenant (for deposit reconciliation)
export const linkTransactionToTenant = (txnId, tenantId, rejectAutoMatch = false) =>
  api.put(`/bank-transactions/${txnId}/link-tenant`, {
    tenant_id: tenantId || null,
    reject_auto_match: !tenantId && rejectAutoMatch ? true : false,
  }).then(r => r.data);

// Report Exports (trigger browser download)
export const downloadReportExport = async (format, params = {}) => {
  const response = await api.get(`/bank-transactions/report/export/${format}`, {
    params,
    responseType: 'blob',
    timeout: 60000,
  });
  // Extract filename from Content-Disposition header
  const disposition = response.headers['content-disposition'] || '';
  const match = /filename="?([^"]+)"?/.exec(disposition);
  const filename = match ? match[1] : `pnl_report.${format}`;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Rules
export const getTransactionRules = () =>
  api.get('/transaction-rules').then(r => r.data);

export const createTransactionRule = (data) =>
  api.post('/transaction-rules', data).then(r => r.data);

export const updateTransactionRule = (id, data) =>
  api.put(`/transaction-rules/${id}`, data).then(r => r.data);

export const deleteTransactionRule = (id) =>
  api.delete(`/transaction-rules/${id}`).then(r => r.data);

export const applyTransactionRules = () =>
  api.post('/transaction-rules/apply', {}, { timeout: 60000 }).then(r => r.data);

// Report Saved Views (server-side)
export const getReportSavedViews = () =>
  api.get('/report-saved-views').then(r => r.data);

export const createReportSavedView = (data) =>
  api.post('/report-saved-views', data).then(r => r.data);

export const updateReportSavedView = (id, data) =>
  api.put(`/report-saved-views/${id}`, data).then(r => r.data);

export const deleteReportSavedView = (id) =>
  api.delete(`/report-saved-views/${id}`).then(r => r.data);
